/**
 * AUTH DEBUG COMPONENT
 * Temporary component to help debug authentication issues
 */

import React, { useState } from 'react';
import { Button } from '../ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { superadminApi } from '../../utils/api';
import { getCompanyHeaders } from '../../utils/tenantContext';
import { authService } from '../../utils/auth/authService';

export function AuthDebug() {
  const [result, setResult] = useState<any>(null);
  const [loading, setLoading] = useState(false);

  const checkAuth = async () => {
    setLoading(true);
    try {
      const response = await superadminApi.get('/debug/check-auth');
      setResult(response);
    } catch (error: any) {
      setResult({ error: error.message });
    } finally {
      setLoading(false);
    }
  };

  const showLocalStorage = () => {
    const currentUser = authService.getCurrentUser();
    const headers = getCompanyHeaders();
    setResult({
      localStorage: {
        auth_user: localStorage.getItem('oilwellx_auth_user'),
        auth_session: sessionStorage.getItem('oilwellx_auth_session'),
      },
      parsedUser: currentUser,
      headers,
    });
  };

  return (
    <Card className="max-w-2xl mx-auto mt-8">
      <CardHeader>
        <CardTitle>🔍 Authentication Debugger</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="flex gap-2">
          <Button onClick={checkAuth} disabled={loading}>
            Check Backend Auth
          </Button>
          <Button onClick={showLocalStorage} variant="outline">
            Check Frontend Storage
          </Button>
        </div>

        {result && (
          <div className="bg-gray-100 p-4 rounded-lg">
            <pre className="text-xs overflow-auto">
              {JSON.stringify(result, null, 2)}
            </pre>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
